<template>
  <div
    id="app"
    class="pdf"
    :style="[scaleStyle, { display: 'block' }]"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <DesignRirekisho002PreviewDoc
      ref="previewDoc"
      :format-data="formatData"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :format-id="formatId"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import DesignRirekisho002PreviewDoc from '@/components/format-edit/design-rirekisho/DesignRirekisho002PreviewDoc.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const previewDoc = ref<{ checkValid?: () => void } | null>(null)
const scaleStyle = computed(() => ({
  transform: `scale(${props.previewScale ?? 1})`,
  'transform-origin': 'top left'
}))

function checkValid() {
  previewDoc.value?.checkValid?.()
}

defineExpose({ checkValid })
</script>
